import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';

/**
 * @param {Object}        model
 * @param {Function}      closeDialog
 * @param {Function}      closeBox
 * @param {String}        formattedProvider
 * @param {Function}      integrationDisconnected
 */
class ConfirmDisconnectDialog extends Component {
  @service flashMessages;

  @task
  *disconnectTask() {
    try {
      yield this.args.model.destroyRecord();
      this.args.closeDialog();
      this.args.closeBox();
      this.args.integrationDisconnected(true);
    } catch (e) {
      this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
    }
  }
}

export default ConfirmDisconnectDialog;
